// src/utils/permissions.js
// ORBIS PMO — C2.8.2B Fix exports requeridos por ProtectedRoute

export const API_BASE = `${window.location.origin}/PM/api`;

export function getToken() {
    return localStorage.getItem("cani_auth") || localStorage.getItem("token") || "";
}

export function authHeaders(extra = {}) {
    const token = getToken();

    return {
        ...extra,
        Authorization: token ? `Bearer ${token}` : "",
        "X-CANI-AUTH": token || "",
    };
}

export function normalizePermissions(raw) {
    if (!raw) return [];

    if (Array.isArray(raw)) {
        return raw.filter(Boolean);
    }

    if (typeof raw === "string") {
        try {
            const parsed = JSON.parse(raw);
            return normalizePermissions(parsed);
        } catch {
            return raw
                .split(",")
                .map((x) => x.trim())
                .filter(Boolean);
        }
    }

    if (typeof raw === "object") {
        return Object.entries(raw)
            .filter(([, value]) => Number(value) === 1 || value === true)
            .map(([key]) => key);
    }

    return [];
}

export function readStoredPermissions() {
    return normalizePermissions(
        localStorage.getItem("cani_permissions") ||
        localStorage.getItem("permissions") ||
        "[]"
    );
}

export function getUserRole() {
    return localStorage.getItem("role") || "pm";
}

export function isAdminRole(role = getUserRole()) {
    const r = String(role || "").toLowerCase();
    return r === "admin" || r === "administrador";
}

export function hasPermission(permission, permissions = readStoredPermissions(), role = getUserRole()) {
    if (!permission) return true;
    if (isAdminRole(role)) return true;

    const list = normalizePermissions(permissions);
    return list.includes(permission);
}

export function hasAnyPermission(required = [], permissions = readStoredPermissions(), role = getUserRole()) {
    if (!required || required.length === 0) return true;
    if (isAdminRole(role)) return true;

    const list = normalizePermissions(permissions);
    return required.some((p) => list.includes(p));
}

export async function fetchMyPermissions() {
    const res = await fetch(`${API_BASE}/permissions_my_permissions.php`, {
        headers: authHeaders(),
    });

    const text = await res.text();
    let data;

    try {
        data = JSON.parse(text);
    } catch {
        throw new Error(`Respuesta no JSON en permisos efectivos: ${text.slice(0, 180)}`);
    }

    if (!res.ok || data.ok === false || data.success === false) {
        throw new Error(data.error || data.detail || `HTTP ${res.status}`);
    }

    const permissions = normalizePermissions(data.permissions || []);

    localStorage.setItem("cani_permissions", JSON.stringify(permissions));

    if (data.role) localStorage.setItem("role", data.role);
    if (data.user?.role) localStorage.setItem("role", data.user.role);
    if (data.user?.id) localStorage.setItem("user_id", String(data.user.id));

    window.dispatchEvent(new Event("cani-permissions-updated"));

    return {
        ...data,
        permissions,
    };
}

export const ROUTE_PERMISSIONS = {
    "/dashboard": "dashboard.view",
    "/dashboardexecutive": "dashboardexecutive.view",
    "/decision-center": "decision_center.view",
    "/projects": "projects.view",
    "/my-work": "tasks.view",
    "/kanban": "tasks.view",
    "/gantt": "tasks.view",
    "/roadmap": "projects.view",
    "/productivity": "dashboard.view",
    "/evidence-map": "evidence.view",
    "/crm-dashboard": "crm_dashboard.view",
    "/crm-quality": "crm_quality.view",
    "/campaigns": "campaigns.view",
    "/accounts": "accounts.view",
    "/opportunities": "opportunities.view",
    "/agenda": "agenda.view",
    "/contacts": "contacts.view",
    "/affiliate-companies": "affiliate_companies.view",
    "/affiliations": "affiliations.view",
    "/institution": "institution.view",
    "/platform-settings": "platform_settings.view",
    "/users": "users.view",
    "/permissions": "permissions.manage",
};

export function permissionForPath(pathname = window.location.pathname) {
    const normalized = pathname.replace(/^\/PM/, "") || "/";

    const match = Object.entries(ROUTE_PERMISSIONS)
        .sort((a, b) => b[0].length - a[0].length)
        .find(([path]) => normalized === path || normalized.startsWith(`${path}/`));

    return match ? match[1] : null;
}
